<!-- 图片预览 -->
<template>
  <div class="image-preview-list">
    <div style="display: flex; flex-wrap: wrap">
      <el-image
        v-for="(img, index) in images"
        :key="index"
        style="width: 50px; height: 50px; margin: 2px"
        :src="safeUrl(img)"
        :preview-src-list="safePreviewList"
        class="image-slot"
      >
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImagePreviewList",
  props: {
    images: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    safePreviewList() {
      return this.images.map((url) => this.safeUrl(url));
    },
  },
  methods: {
    safeUrl(url) {
      try {
        return encodeURI(url);
      } catch (e) {
        return url;
      }
    },
  },
};
</script>

<style scoped>
.image-preview-list .image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
}
/* 控制预览图大小 */
::v-deep .el-image-viewer__wrapper img {
  max-width: 500px;
  max-height: 500px;
  width: auto;
  height: auto;
}
::v-deep .el-image-viewer__img {
  max-width: 500px;
  max-height: 500px;
}
</style>
